/**
 * SankeyDiagramEditor
 *
 * Property editor for Sankey diagram configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';
import { NumberPropertyEditor } from '../../BaseEditors/NumberPropertyEditor';

export interface SankeyDiagramEditorProps {
  config: Partial<ChartBaseConfig & {
    sourceKey?: string;
    targetKey?: string;
    valueKey?: string;
    nodeWidth?: number;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const SankeyDiagramEditor: React.FC<SankeyDiagramEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Sankey Diagram" showAxes={false}>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Sankey Options</h3>

        <TextPropertyEditor
          label="Source Key"
          value={(config.sourceKey as string) || 'source'}
          onChange={(sourceKey) => onChange({ ...config, sourceKey })}
          helpText="Property for flow source nodes"
          required
        />

        <TextPropertyEditor
          label="Target Key"
          value={(config.targetKey as string) || 'target'}
          onChange={(targetKey) => onChange({ ...config, targetKey })}
          helpText="Property for flow target nodes"
          required
        />

        <TextPropertyEditor
          label="Value Key"
          value={(config.valueKey as string) || 'value'}
          onChange={(valueKey) => onChange({ ...config, valueKey })}
          helpText="Property for flow magnitude"
          required
        />

        <NumberPropertyEditor
          label="Node Width"
          value={(config.nodeWidth as number) || 40}
          onChange={(nodeWidth) => onChange({ ...config, nodeWidth })}
          min={10}
          max={100}
          step={5}
          suffix="px"
        />
      </div>
    </ChartBaseEditor>
  );
};

SankeyDiagramEditor.displayName = 'SankeyDiagramEditor';
